<template>
  <div>
  <v-form ref="form" @submit.prevent="submit" :lazy-validation="true" v-model="valid" :disabled="isSaving">
    <v-card>
      <v-card-text class="operator-form__content">
        <div class="title text--primary">
          General Info
        </div>

        <div class="">
          <v-text-field
            label="Name"
            name="operatorname"
            v-model="ownOperator.name"
            :rules="stringValidation"
          ></v-text-field>

          <v-text-field
            label="Description"
            name="description"
            v-model="ownOperator.description"
            :rules="stringValidation"
          ></v-text-field>

          <v-textarea
            v-model="ownOperator.payment_note"
            label="Payment note"
            :auto-grow="true"
            rows="1"
          ></v-textarea>

          <here-map-input
            label="Location"
            v-model="ownOperator.location"
            strings
            apikey="MUVQA9DZRPqLReov2aCtS4SKVJ8frldNGdo-wNA11I8"
            :defaultValue="defaultMapLocation"
            :defaultZoom="4"
          ></here-map-input>
        </div>

          <v-row>
            <v-col cols="6">
              <v-checkbox
                v-model="ownOperator.hidden"
                label="Hidden"
                messages="Hidden operators are not shown in the app and can't take orders"
              ></v-checkbox>
            </v-col>

            <v-col cols="6">
              <v-checkbox
                v-model="ownOperator.unlisted"
                label="Unlisted"
                messages="Unlisted operators are not shown in the app but can take orders"
              ></v-checkbox>
            </v-col>
          </v-row>

        <v-divider class="mt-3 mb-3"/>

        <v-row align="center" justify="center">
          <v-col cols="8">
            <v-checkbox
              v-model="ownOperator.terms_custom"
              label="Custom Purchasing Terms"
              messages="Setting your own terms overrides the default terms of purchase."
            ></v-checkbox>
          </v-col>
          <v-col cols="4">
            <v-btn tile @click.stop="openTermsForm">
              <v-icon left>
                mdi-pencil
              </v-icon>
              Edit terms
            </v-btn>
          </v-col>
        </v-row>

        <v-divider class="mt-3 mb-3"/>

        <div class="">
          <v-expansion-panels flat hover multiple v-model="optionsExpanded">
            <v-expansion-panel>
              <v-expansion-panel-header class="px-0 title"
              @click="scrollToOption($event)">Open hours</v-expansion-panel-header>
              <v-expansion-panel-content>
                <open-hours
                  ref="openhours"
                  :regular="ownOperator.regular_open_hours"
                  @regular="$set(ownOperator, 'regular_open_hours', $event)"
                  :irregular="ownOperator.irregular_open_hours"
                  @irregular="$set(ownOperator, 'irregular_open_hours', $event)"
                ></open-hours>
              </v-expansion-panel-content>
            </v-expansion-panel>


            <v-expansion-panel>
              <v-expansion-panel-header class="px-0 title"
              @click="scrollToOption($event)">Options</v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="mb-4">
                  <v-row dense>
                    <v-col cols="12" sm="6">
                      <v-switch
                        label="Table ordering"
                        v-model="ownOperator.table_ordering"
                        color="primary"
                      />
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-switch
                        label="Table bills"
                        v-model="ownOperator.table_bills"
                        :disabled="!ownOperator.table_ordering"
                        color="primary"
                      />
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-tooltip top nudge-left="80">
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            <v-switch
                              label="Delivery Time"
                              v-model="ownOperator.delivery_time"
                              color="primary"
                            />
                          </div>
                        </template>
                        <span>Allow users to request a time when the order is complete</span>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-switch
                        label="Product Categories"
                        v-model="ownOperator.product_categories"
                        color="primary"
                      />
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-switch
                        v-model="ownOperator.barview_messages"
                        color="primary"
                        label="Barview messages"
                      />
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-tooltip top nudge-left="80">
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            <v-switch
                              label="Wait for orders"
                              v-model="ownOperator.wait_for_orders"
                              color="primary"
                            />
                          </div>
                        </template>
                        <span>Try to batch orders together for a specific table or device</span>
                      </v-tooltip>
                    </v-col>

                  </v-row>

                  <div class="mt-4">
                    <div class="title text--primary">
                      Layout
                    </div>

                    <v-select
                      label="Main layout"
                      :items="itemsLayouts"
                      v-model="ownOperator.layout_items"
                    >
                      <template v-slot:item="{item}">
                        <div class="">
                          {{item.text}}
                        </div>
                        <v-spacer />
                        <v-btn
                          v-if="item.description"
                          @click.stop="$dialog({message: item.description, title: item.text})"
                          text icon
                        >
                          <v-icon>mdi-information-outline</v-icon>
                        </v-btn>
                      </template>
                    </v-select>

                    <v-combobox
                      label="Status view layout"
                      :items="statusViewLayouts"
                      :return-object="false"
                      v-model="ownOperator.layout_status_view"
                    >
                      <template v-slot:item="{item}">
                        <div class="">
                          {{item.text}}
                        </div>
                        <v-spacer />
                        <v-btn
                          v-if="item.description"
                          @click.stop="$dialog({message: item.description, title: item.text})"
                          text icon
                        >
                          <v-icon>mdi-information-outline</v-icon>
                        </v-btn>
                      </template>
                    </v-combobox>
                  </div>

                  <div class="mt-4">
                    <div class="title text--primary">
                      Payments
                    </div>
                    <v-row dense>
                      <v-col cols="12" sm="6">
                        <v-radio-group v-model="ownOperator.cardreader_brand" :disabled="isSaving">
                          <v-radio label="iZettle" color="primary" value="izettle"></v-radio>
                          <v-radio label="Bambora" color="primary" value="bambora"></v-radio>
                          <v-radio label="None" color="primary" value="none"></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-checkbox
                          class="compact-checkbox-first"
                          label="Swish"
                          v-model="ownOperator.payment_swish"
                          color="primary"
                          hide-details
                        />
                        <v-checkbox
                          class="compact-checkbox"
                          label="Bambora Checkout"
                          v-model="ownOperator.payment_checkout"
                          color="primary"
                          hide-details
                        />
                        <v-checkbox
                          class="compact-checkbox"
                          label="Invoice"
                          v-model="ownOperator.payment_invoice"
                          color="primary"
                          hide-details
                        />
                      </v-col>
                    </v-row>
                  </div>

                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>


            <v-expansion-panel>
              <v-expansion-panel-header class="px-0 title"
              @click="scrollToOption($event)">Advanced</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card-text class="operator-form__content">
                  <div class="title text--primary">
                    Wait for orders
                  </div>

                  <div class="">
                    <v-text-field
                      label="Linger time"
                      name="lingertime"
                      v-model.trim="ownOperator.wait_for_orders_time_linger"
                      :rules="stringValidation"
                    ></v-text-field>

                    <v-text-field
                      label="Active time"
                      name="activetime"
                      v-model.trim="ownOperator.wait_for_orders_time_active"
                      :rules="stringValidation"
                    ></v-text-field>

                    <v-text-field
                      label="Total time"
                      name="totaltime"
                      v-model.trim="ownOperator.wait_for_orders_time_total_limit"
                      :rules="stringValidation"
                    ></v-text-field>
                  </div>

                </v-card-text>

              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn color="primary" depressed :disabled="!valid" :loading="isSaving" type="submit">Save</v-btn>
        <v-btn color="primary" text @click="cancel" :disabled="isSaving">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
  <v-dialog :value="editingTerms" max-width="600px" persistent scrollable>
    <terms-form v-bind:ownOperator="ownOperator" @close-terms-form="closeTermsForm"/>
  </v-dialog>
</div>
</template>

<style scoped>
.compact-checkbox-first {
  margin-top: 16px;
}
.compact-checkbox {
  margin-top: 4px;
}
</style>

<script>
import {HereMapInput} from 'dync-heremap';
import {OpenHours} from 'dync-datetime';
import itemsLayouts from './itemsLayouts';
import statusViewLayouts from './statusViewLayouts';
import TermsForm from './TermsForm';

export default {
  props: {
    operator: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    var stringValidation = v => !!v || 'Cannot be empty';

    return {
      editingTerms: false,
      optionsExpanded: [],
      valid: true,
      stringValidation: [stringValidation],
      ownOperator: {},
      defaultMapLocation: {
        lat: '61.571740688429685',
        lng: '16.150541744631454'
      },
      itemsLayouts,
      statusViewLayouts
    }
  },
  watch: {
    operator (newVal) {
      this.setOwnOperator(newVal);
    }
  },
  computed: {
    isSaving() {
      return this.$store.getters.isLoadingFor('operators.update');
    }
  },
  methods: {
    openTermsForm () {
      this.editingTerms = true;
    },
    closeTermsForm () {
      this.editingTerms = false;
    },
    setOwnOperator (operator) {
      this.ownOperator = Object.assign({
        // Default wait_for_orders values
        wait_for_orders_time_linger: 300,
        wait_for_orders_time_active: 120,
        wait_for_orders_time_total_limit: 900,
        // Default layout for items
        layout_items: '2-grid',
        // Default layout for status view
        layout_status_view: '4-step'
      }, operator);

      // Delete obsolete values
      this.ownOperator.opening_hours_from = null;
      this.ownOperator.opening_hours_to = null;
      this.ownOperator.take_away_from = null;
      this.ownOperator.take_away_to = null;

      // Default wait_for_orders values
      if (this.ownOperator.wait_for_orders_time_linger === undefined) {
        this.ownOperator.wait_for_orders_time_linger = 300;
      }
      if (this.ownOperator.wait_for_orders_time_active === undefined) {
        this.ownOperator.wait_for_orders_time_active = 120;
      }
      if (this.ownOperator.wait_for_orders_time_total_limit === undefined) {
        this.ownOperator.wait_for_orders_time_total_limit = 900;
      }

      // Default cardreader brand
      if (this.ownOperator.cardreader_brand === undefined) {
        this.ownOperator.cardreader_brand = "none";
      }

      // Default payment Swish
      if (this.ownOperator.payment_swish === undefined) {
        this.ownOperator.payment_swish = true;
      }

      // Default payment Invoice
      if (this.ownOperator.payment_invoice === undefined) {
        this.ownOperator.payment_invoice = false;
      }

      // Default Unlisted
      if (this.ownOperator.unlisted === undefined) {
        this.ownOperator.unlisted = false;
      }

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    scrollToOption (e) {
      setTimeout(() => {
        if (this.optionsExpanded.length !== 0) {
          e.target.scrollIntoView({ behavior: "smooth" });
        }
      }, 200);
    },
    cancel () {
      this.$emit('cancel');
    },
    submit () {
      if (this.$refs.form.validate())
        this.$emit('submit', this.ownOperator);
    },
    reset () {
      this.setOwnOperator(this.operator);
      this.optionsExpanded = [];
      if (this.$refs.openhours) {
        this.$refs.openhours.reset();
      }
    }
  },
  mounted () {
    if (this.operator)
      this.setOwnOperator(this.operator);
  },
  components: {
    HereMapInput,
    OpenHours,
    TermsForm
  }
}
</script>
